<template>
	<div class="container__cardmap">
		<div class="container__cardmap__searchlist">
			<div class="container__cardmap__searchlist__search">
				<InputSearch
					v-model="textFilter"
					:placeholder="$t('pesquisar')"
				/>
			</div>
			<div class="container__cardmap__searchlist__list">
				<div id="gerarPoligono" />
				<Loading v-if="isLoadingCardMap" />
				<div v-else>
					<CardMapInfoItem
						v-for="mapInfo in itemsToBeShowedAndTotal.items"
						:key="mapInfo.id"
						:is-dashboard-geral="isDashboardGeral"
						:map-info="mapInfo"
						:set-fazenda-id="setFazendaId"
					/>
				</div>
			</div>
			<div class="container__cardmap__searchlist__pagination">
				<Pagination
					ref="pagination"
					:total-records="itemsToBeShowedAndTotal.total"
					:quantity-per-page-options="[3, 6, 9]"
					:quantity-per-page="quantityPerPage"
					@setStartEnd="setStartEnd"
					@setQuantityPerPage="setQuantityPerPage"
				/>
			</div>
		</div>
		<div class="container__cardmap__gmap">
			<DashboardMap
				:is-dashboard-geral="isDashboardGeral"
				:set-fazenda-id="setFazendaId"
			>
				<slot />
			</DashboardMap>
		</div>
	</div>
</template>

<script>
import InputSearch from '../../../components/InputSearch/InputSearch'
import Loading from '../../../components/Loading/Loading'
import Pagination from '../../../components/Pagination/Pagination'
import CardMapInfoItem from './CardMapInfoItem/CardMapInfoItem'
import DashboardMap from './DashboardMap/DashboardMap'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'

import _ from 'lodash'

export default {
	components: {
		CardMapInfoItem,
		DashboardMap,
		InputSearch,
		Loading,
		Pagination,
	},
	mixins: [ControllingPaginationMixins],
	props: {
		/**
		 * Variavel para controlar se esta em dashboard geral ou nao
		 */
		isDashboardGeral: Boolean,
		/**
		 * Funcao para setar o id da fazenda do componente pai
		 */
		setFazendaId: Function,
	},
	data: () => {
		return {
			/**
			 * Filtro para ser aplicado
			 */
			textFilter: '',
		}
	},
	computed: {
		/**
		 * Estado que verifica se esta bucando dados do backend para o componente CardMap
		 */
		isLoadingCardMap() {
			return this.$store.state.moduleDashboardCardInfo.isLoadingCardMap
		},
		/**
		 * Propriedade computada que retorna apenas os itens filtrados e de acordo com a quantidade
		 * de itens por pagina
		 */
		itemsToBeShowedAndTotal: function () {
			const itemsFiltred = this.$store.getters[
				'moduleDashboardCardInfo/cardInfoFiltredByTitleAndInfos'
			](this.textFilter)

			return {
				items: _.orderBy(itemsFiltred, ['existeProcessamento', 'titulo'], ['desc', 'asc']).slice(
					this.atualStartIndex,
					this.atualEndIndex,
				),
				total: itemsFiltred.length,
			}
		},
	},
	watch: {
		/**
		 * Reseta para a primeira pagina quando o filtro é alterado
		 */
		textFilter: function () {
			this.$refs.pagination.resetToFirstPage()
		},
	},
	created() {
		/**
		 * Quantidade de itens por pagina
		 */
		this.quantityPerPage = 3
	},
	methods: {
		/**
		 * Reseta para a primeira pagina dos cards
		 */
		resetToFirstPage() {
			this.$refs.pagination.resetToFirstPage()
		},
		/**
		 * Reseta o input de texto do filtro
		 */
		resetTextFilter() {
			this.textFilter = ''
		},
	},
}
</script>

<style scoped>
.container__cardmap {
	padding: 0;
	display: flex;
	flex-direction: column;
}

.container__cardmap__searchlist {
	padding: 1rem 1rem 0 1rem;
	width: 79vw;

	margin: 0 auto;
}

.container__cardmap__searchlist__search {
	height: 100%;
}

.container__cardmap__searchlist__list {
	height: auto;
	display: flex;
	overflow: auto;
	flex-direction: row;
}

.container__cardmap__searchlist__pagination {
	display: flex;
	justify-content: center;
}

.container__cardmap__gmap {
	height: 33rem;
	width: 100%;
}

@media screen and (min-width: 992px) {
	.container__cardmap {
		flex-direction: row;
		height: 35rem;
	}

	.container__cardmap__searchlist {
		padding: 1rem;
	}

	.container__cardmap__searchlist {
		display: flex;
		flex-direction: column;
		width: 35%;
	}

	.container__cardmap__searchlist__search {
		max-height: 3.5rem;
	}

	.container__cardmap__searchlist__list {
		height: 100%;
		flex-direction: column;
	}

	.container__cardmap__searchlist__pagination {
		justify-content: flex-end;
	}

	.container__cardmap__gmap {
		width: 65%;
		height: 100%;
	}
}
</style>
